import { fixResponseJSON, filterParams } from "../assets/helpers/funciones";
import { authInstance } from "./axios";
let url = process.env.REACT_APP_API_URL;

export const servicesService = {
  createAVService: async (data) => {
    const myInit = {
      headers: {
        "x-api-key": process.env.REACT_APP_X_API_KEY,
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      method: "POST",
      body: data,
    };

    const response = await fetch(`${url}/services/createAv`, myInit)
      .then(async (response) => {
        return fixResponseJSON(response);
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  conciliateService: async (data) => {
    const response = await authInstance
      .put(`${url}/services/reconcile`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  reconcileFile: async (data) => {
    const response = await authInstance
      .post(`${url}/services/reconcileFile`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  getProviderETA: async (serviceId) => {
    const response = await authInstance
      .get(`${url}/services/${serviceId}/providersEta`)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  getServicesByOperator: async (params) => {
    const response = await authInstance
      .get(
        `${url}/services/servicesByOperator/?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  getServicesByOperatorTV: async (params) => {
    const response = await authInstance
      .get(
        `${url}/services/servicesByOperatorTV?` +
          new URLSearchParams(filterParams(params || {}))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  getSupervisorServices: async (params) => {
    const response = await authInstance
      .get(
        `${url}/services/supervisorFinishedServices/?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },
  getTaxiOtp: async (serviceId) => {
    const response = await authInstance
      .get(`${url}/services/${serviceId}/taxiOtp`)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  validateTaxiOtp: async (serviceId, data) => {
    const response = await authInstance
      .post(`${url}/services/${serviceId}/validateTaxiOtp`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  requestOTP: async (serviceId, params) => {
    const response = await authInstance
      .get(
        `${url}/services/${serviceId}/serviceOtp?` + new URLSearchParams(params)
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  validateOTP: async (serviceId, data) => {
    const response = await authInstance
      .post(`${url}/services/${serviceId}/validateOtp`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  requestRideryTowOtp: async (params) => {
    const response = await authInstance
      .get(`${url}/services/rideryTowOtp?` + new URLSearchParams(params))
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  validateRideryTowOtp: async (data) => {
    const response = await authInstance
      .post(`${url}/services/validateRideryTowOtp`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  cancelService: async (data, serviceId) => {
    const response = await authInstance
      .post(`${url}/services/${serviceId}/cancel`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  rescheduleService: async (data, serviceId) => {
    const response = await authInstance
      .put(`${url}/services/${serviceId}/reschedule`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  rescheduleTow: async (data, serviceId) => {
    const response = await authInstance
      .put(`${url}/services/${serviceId}/rescheduleTow`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  unschedule: async (serviceId) => {
    const response = await authInstance
      .put(`${url}/services/${serviceId}/unschedule`)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  getExportables: async (params) => {
    for (const key in params) {
      if (params[key] === undefined || params[key] === "") {
        delete params[key];
      }
    }

    const response = await authInstance
      .get(
        `${url}/services/exportablePendingPayment?` +
          new URLSearchParams(params)
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  getLocksmithExportable: async (params) => {
    for (const key in params) {
      if (params[key] === undefined || params[key] === "") {
        delete params[key];
      }
    }

    const response = await authInstance
      .get(`${url}/services/locksmith?` + new URLSearchParams(params))
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },
  getExportableAdmin: async (params) => {
    for (const key in params) {
      if (params[key] === undefined || params[key] === "") {
        delete params[key];
      }
    }

    const response = await authInstance
      .get(`${url}/payments/exportableAdminOp?` + new URLSearchParams(params))
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  getPaymentsValidation: async (params) => {
    for (const key in params) {
      if (params[key] === undefined || params[key] === "") {
        delete params[key];
      }
    }

    const response = await authInstance
      .get(
        `${url}/payments/listServicesPayments?` +
          new URLSearchParams(filterParams(params || {}))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  validatePayment: async (data) => {
    const response = await authInstance
      .post(`${url}/payments/validatePayment`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log("error", error);
        error.data = [];
        return error;
      });
    return response;
  },

  getTowExceptionsOptions: async (params) => {
    const response = await authInstance
      .get(
        `${url}/services/towExceptionReasons/?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  uploadAVImage: async (file, serviceId) => {
    const myInit = {
      headers: {
        "x-api-key": process.env.REACT_APP_X_API_KEY,
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      method: "PUT",
      body: file,
    };

    const response = await fetch(
      `${url}/services/${serviceId}/uploadAvImage`,
      myInit
    )
      .then(async (response) => {
        return fixResponseJSON(response);
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  uploadSolvedAvImage: async (file, serviceId) => {
    const myInit = {
      headers: {
        "x-api-key": process.env.REACT_APP_X_API_KEY,
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      method: "PUT",
      body: file,
    };

    const response = await fetch(
      `${url}/services/${serviceId}/uploadSolvedAvImage`,
      myInit
    )
      .then(async (response) => {
        return fixResponseJSON(response);
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  uploadTowImage: async (file, serviceId) => {
    const myInit = {
      headers: {
        "x-api-key": process.env.REACT_APP_X_API_KEY,
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      method: "PUT",
      body: file,
    };

    const response = await fetch(
      `${url}/services/${serviceId}/uploadTowImages`,
      myInit
    )
      .then(async (response) => {
        return fixResponseJSON(response);
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  updateLocksmith: async (serviceId, data) => {
    const myInit = {
      headers: {
        "x-api-key": process.env.REACT_APP_X_API_KEY,
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      method: "PUT",
      body: data,
    };

    const response = await fetch(
      `${url}/services/${serviceId}/updateLocksmith`,
      myInit
    )
      .then(async (response) => {
        return fixResponseJSON(response);
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  getUploadedImages: async (serviceId) => {
    const myInit = {
      headers: {
        "x-api-key": process.env.REACT_APP_X_API_KEY,
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      method: "GET",
    };

    const response = await fetch(
      `${url}/services/${serviceId}/getUploadedImages`,
      myInit
    )
      .then(async (response) => {
        return fixResponseJSON(response);
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },
  updateProvider: async (data, serviceId) => {
    const myInit = {
      headers: {
        "Content-type": "application/json",
        "x-api-key": process.env.REACT_APP_X_API_KEY,
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      method: "PUT",
      body: JSON.stringify(data),
    };

    const response = await fetch(
      `${url}/services/${serviceId}/updateProvider`,
      myInit
    )
      .then(async (response) => {
        return fixResponseJSON(response);
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  createTowService: async (data) => {
    const response = await authInstance
      .post(`${url}/services/createTow`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  updateTowService: async (data, serviceId) => {
    const myInit = {
      headers: {
        "x-api-key": process.env.REACT_APP_X_API_KEY,
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      method: "PUT",
      body: data,
    };

    const response = await fetch(
      `${url}/services/${serviceId}/updateTow`,
      myInit
    )
      .then(async (response) => {
        return fixResponseJSON(response);
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  createLocksmith: async (data) => {
    const response = await authInstance
      .post(`${url}/services/createLocksmith`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  updateLocksmith: async (data, serviceId) => {
    const myInit = {
      headers: {
        "x-api-key": process.env.REACT_APP_X_API_KEY,
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      method: "PUT",
      body: data,
    };

    const response = await fetch(
      `${url}/services/${serviceId}/updateLocksmith`,
      myInit
    )
      .then(async (response) => {
        return fixResponseJSON(response);
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  updateAV: async (caseId, data) => {
    const response = await authInstance
      .put(`${url}/services/${caseId}/updateAv`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  getsolvedFaultServices: async (params) => {
    const response = await authInstance
      .get(
        `${url}/services/solvedFaultServices/?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  uptateSolvedFaultServices: async (id, body) => {
    const response = await authInstance
      .put(`${url}/services/${id}/updateSolvedByAvStatus/?`, body)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  getServicesByCode: async (code) => {
    const response = await authInstance
      .get(`${url}/services/servicesByCode/?code=${code}`)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  getLatestPap: async (membershipId) => {
    const response = await authInstance
      .get(`${url}/services/getLatestPap?membership=${membershipId}`)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  getOperatorCommissions: async (params) => {
    const response = await authInstance
      .get(
        `${url}/services/operatorComission/?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },
};
